import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { Survey } from '@lyra/app/pages/questionnaire/core/classes/survey.class';
import { skipWhile, take, tap } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { PlanActionsService } from '../store/actions';
import { PlanSelectService } from '../store/selectors/plan.selector';

export const planResolver: ResolveFn<Survey | undefined> = () => {
  const _select = inject(PlanSelectService);
  const _actions = inject(PlanActionsService);
  const _platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(_platformId)) {
    return undefined;
  }
  return _select.getSurvey().pipe(
    tap((actionPlan) => {
      if (actionPlan === undefined) {
        _actions.getLastCompletedSurvey();
      }
    }),
    switchMap(() =>
      _select.getSurvey().pipe(
        skipWhile((v) => v === null || v === undefined),
        take(1),
      ),
    ),
  );
};
